import React, { useContext } from 'react';
import T from 'prop-types';

import ExportsViewContext from '../../../../../components/AdvancedExportModal/ExportsViewContext';
import {
  Menu,
  MenuItem,
  MenuDivider,
  MenuButton,
  useMenuProps,
} from '../../../../../components/DropdownSet';

import { allowedExportPages, initParams } from '../../../app-overview/_shared/config/export-params';

const emptyArray = [];

const AlertsDropdown = ({
  prependCustomOptions = emptyArray,
  appendCustomOptions = emptyArray,
}) => {
  const menuProps = useMenuProps({
    align: 'end',
    menuStyle: { width: 238 },
    menuClassName: 'alerts-dropdown',
  });

  const { openAdvancedExportModal } = useContext(ExportsViewContext);

  return (
    <Menu
      menuButton={
        <MenuButton shape="square" caret={false} variant="light" className="alerts-dropdown-btn">
          <i className="hicon-more-vert" />
        </MenuButton>
      }
      {...menuProps}
    >
      {prependCustomOptions.map(({ key, item }, index) => (
        <MenuItem key={key || index} className="additional-options additional-options--prepend">
          {item}
        </MenuItem>
      ))}
      <MenuDivider fullWidth dense />
      {initParams?.permissions?.allowAdvancedExportModal &&
        allowedExportPages.includes(initParams.pageName) && (
          <MenuItem
            className="additional-options additional-options--append additional-options__export"
            onClick={openAdvancedExportModal}
          >
            <span>
              <i className="hicon-download-thin" />
              {initParams?.permissions?.allowAdvancedExportModal ? 'Export Data' : 'Advanced Export'}
            </span>
          </MenuItem>
        )}
      {appendCustomOptions.map(({ key, item }, index) => (
        <MenuItem key={key || index} className="additional-options additional-options--append">
          {item}
        </MenuItem>
      ))}
    </Menu>
  );
};

AlertsDropdown.propTypes = {
  prependCustomOptions: T.array,
  appendCustomOptions: T.array,
};

export default AlertsDropdown;
